export const policyGroups = [
  {
    title: "Shopping policies",
    links: [
      { label: "Shipping & delivery", to: "/shipping", description: "Delivery areas, timing, fees and chilled handover." },
      { label: "Returns & refunds", to: "/returns", description: "What to do when an order arrives damaged or incorrect." },
      { label: "Orders & cancellations", to: "/orders", description: "Order acceptance, changes, substitutions and cancellations." },
      { label: "Payments & billing", to: "/payments", description: "Payment authorisation, currency, refunds and chargebacks." },
      { label: "Product information & pricing", to: "/product-information", description: "Descriptions, images, weights, availability and price errors." },
      { label: "Food safety & allergens", to: "/food-safety", description: "Allergen checks, storage, dates, recalls and food safety." },
      { label: "International orders", to: "/international-orders", description: "Cross-border availability, duties, customs and restrictions." },
      { label: "Promotions & discount codes", to: "/promotions", description: "Eligibility, code use, exclusions, returns and fair use." },
    ],
  },
  {
    title: "Privacy, account & security",
    links: [
      { label: "Privacy policy", to: "/privacy", description: "How personal information is collected, used, shared and retained." },
      { label: "Data rights & marketing choices", to: "/data-rights", description: "Access, correction, deletion and direct-marketing choices." },
      { label: "Cookie policy", to: "/cookies", description: "Essential browser storage and how to manage it." },
      { label: "Account policy", to: "/account-policy", description: "Account eligibility, accuracy, security and closure." },
      { label: "Security & fraud prevention", to: "/security", description: "Protecting transactions and reporting suspicious activity." },
    ],
  },
  {
    title: "Website & legal",
    links: [
      { label: "Terms & conditions", to: "/terms", description: "The main terms that apply when you browse and order." },
      { label: "Acceptable use", to: "/acceptable-use", description: "Rules for lawful and responsible use of the website." },
      { label: "Intellectual property", to: "/intellectual-property", description: "Ownership, permitted use and rights-holder notices." },
      { label: "Accessibility", to: "/accessibility", description: "Our accessibility approach and how to request assistance." },
      { label: "Complaints & dispute resolution", to: "/complaints", description: "How we review complaints and work toward a resolution." },
      { label: "Website disclaimer", to: "/disclaimer", description: "Important limits on general and product information." },
    ],
  },
];

export const policyLinks = policyGroups.flatMap((group) => group.links);

